/**
 * Class uses for determining the current app environment
 */
const getNormalizedEnvironment = (): string => {
  const processEnv = process.env.REACT_APP_ENV;

  if (!processEnv) return 'development';

  const lowerEnv = processEnv.toLowerCase();
  return lowerEnv.startsWith('prod') ? 'production' : lowerEnv;
}

const ENV = getNormalizedEnvironment();

export default class Environment {
  static toString = (): string => ENV;
  static isProduction = (): boolean => ENV === 'production';
}